import { useState } from 'react';
import { ResponseParams, requestHttpGet } from 'requests/RequestBase';
import { HttpStatus } from 'consts/HttpStatus';

export type ZipResponse = {
	zipcode: string;
	prefcode: string;
	address1: string;
	address2: string;
	address3: string;
};

/**
 * 住所検索
 */
export const useSearchAddress = () => {
	// 表示する確定データ
	const [zipResponse, setZipResponse] = useState<ZipResponse>(undefined);
	// レスポンスが複数あった場合にデータを格納し、ダイアログで参照する
	const [zipResponses, setZipResponses] = useState<ZipResponse[]>([]);
	const [isDialogOpen, setIsDialogOpen] = useState(false);
	const doSelect = (data: ZipResponse) => {
		setZipResponse(data);
		setIsDialogOpen(false);
	};
	const doClose = () => {
		setIsDialogOpen(false);
	};
	const searchAddress = async (zipcode: string) => {
		if (!zipcode.match(/^[0-9]{5,}$/)) {
			alert('郵便番号は半角数字5桁以上でご入力ください。');
			return;
		}

		// 住所検索API実行
		const url = `${process.env.REACT_APP_ZIPGET_URL}?zip=${zipcode}`;
		const result: ResponseParams<{ results: ZipResponse[] }> = await requestHttpGet(url);
		if (result.status !== HttpStatus.OK || result.data.results.length === 0) {
			alert('該当の住所がありません。');
			return;
		}

		const data = result.data.results;
		if (!data) {
			return;
		}

		if (data.length === 1) {
			setZipResponse(data[0]);
		} else {
			setZipResponses(data);
			setIsDialogOpen(true);
		}
	};

	return {
		searchAddress,
		zipResponse,
		zipResponses,
		isDialogOpen,
		doSelect,
		doClose,
	};
};
